import React from 'react';
import TermsOfServiceES from './termsOfServiceES';
import TermsOfServiceEN from './termsOfServiceEN';
import TermsOfServiceCA from './termsOfServiceCA';
import { useParams } from 'react-router-dom';

const TermsOfService: React.FC = () => {
    const { lang } = useParams<{ lang?: string }>();
    const storedLang = localStorage.getItem('language');
    const language = lang || storedLang || 'es';

    if (language === 'es') {
        return (
            <TermsOfServiceES />
        );
    }
    else if (language === 'en') {
        return (
            <TermsOfServiceEN />
        );
    }
    else if (language === 'ca') {
        return (
            <TermsOfServiceCA />
        );
    }
    else {
        return (
            <TermsOfServiceES />
        );
    }
};

export default TermsOfService;
